import React from "react";
import "../../assets/scss/components/Common/ErrorBoundary.scss";

class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error) {
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
      console.error("ErrorBoundary caught an error:", error, errorInfo);
    }
  
    render() {
      if (this.state.hasError) {
        return (
          <div className="error-boundary-container">
            <div className="error-card">
              <div className="error-icon-wrapper">
                <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
              </div>
              <h1 className="error-title">Oops! Something went wrong</h1>
              <p className="error-subtitle">
                An unexpected error occurred while loading this page. Don't worry, our team has been notified and we are working to resolve the issue.
              </p>
              <div className="error-actions">
                <button 
                  className="btn-error-refresh" 
                  onClick={() => window.location.reload()}
                >
                  <i className="fa fa-refresh" style={{ marginRight: '8px' }}></i> Refresh Page
                </button>
                <button 
                  className="btn-error-home" 
                  onClick={() => window.location.href = '/'}
                >
                  <i className="fa fa-home" style={{ marginRight: '8px' }}></i> Go to Home
                </button>
              </div>
            </div>
          </div>
        );
      }
  
      return this.props.children; 
    }
  }

export default ErrorBoundary;